import { Navigate, Outlet, useLocation } from "react-router-dom";
import Auth from "../../../helpers/auth.service";

/**
 * Outlet-style auth guard. Mounted as parent route element.
 * If no token+user, redirect to /login with `from` state preserved.
 */
function RequireAuth() {
  const location = useLocation();
  const { token, user } = Auth;

  if (!user || !token || token === undefined || Object.keys(user).length === 0) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export default RequireAuth;
